import { WedgeDownSvgIcon } from './svg';
import { makeIcon } from './make-icon';

export const WedgeDownIcon = makeIcon(WedgeDownSvgIcon, 'WedgeDownIcon')`
  position: relative;
  top: 0.17em;
  path {
    fill: currentColor;
  }
`;
